import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi, setAdminToken } from "@/api/adminOneClient";
import OracleLogo from "@/components/OracleLogo";

export default function AdminOneLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [totp, setTotp] = useState("");
  const [need2fa, setNeed2fa] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const payload = { email, password };
      if (need2fa && totp) payload.totp_code = totp;
      const { data } = await adminApi.login(payload.email, payload.password, payload.totp_code);
      setAdminToken(data.access_token, data.user);
      navigate("/adminone/telemetry", { replace: true });
    } catch (e) {
      const d = e?.response?.data;
      let msg = e?.message || "Login failed";
      if (typeof d?.detail === "string") msg = d.detail;
      else if (Array.isArray(d?.detail) && d.detail[0]?.msg) msg = d.detail[0].msg;
      if (typeof msg === "string" && msg.toLowerCase().includes("2fa")) {
        setNeed2fa(true);
      }
      setErr(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-shell" data-testid="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-crest" aria-hidden="true">
          <OracleLogo size={64} title="CareLogix ORACLE — GIOS" />
        </div>
        <div className="admin-login-kicker">CareLogix™ ORACLE · GIOS™</div>
        <h1 className="admin-login-title">AdminOne Command Center</h1>
        <p className="admin-login-sub">
          Global Intelligence Operating System™ — Authorized operators only. All actions are audited.
        </p>
        <form onSubmit={submit} className="admin-login-form">
          <label className="oracle-field">
            <span>Email</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
              data-testid="admin-login-email"
              placeholder="contact@carelogix360.com"
            />
          </label>
          <label className="oracle-field">
            <span>Password</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              data-testid="admin-login-password"
              placeholder="••••••••"
            />
          </label>
          {err && <div className="oracle-error" role="alert" data-testid="admin-login-error">{err}</div>}
          {need2fa && (
            <label className="oracle-field">
              <span>2FA Code (TOTP)</span>
              <input
                type="text"
                inputMode="numeric"
                pattern="\d{6}"
                maxLength={6}
                value={totp}
                onChange={(e) => setTotp(e.target.value)}
                data-testid="admin-login-totp"
                placeholder="6-digit code"
                autoFocus
              />
            </label>
          )}
          <button
            type="submit"
            className="oracle-btn oracle-btn--gold admin-login-submit"
            disabled={loading}
            data-testid="admin-login-submit"
          >
            {loading ? "…" : "Enter Command Center"}
          </button>
        </form>
        <div className="admin-login-foot">
          Internal access only. Plaintext credentials are never stored.
        </div>
      </div>
    </div>
  );
}
